var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"placeholder":"Todas","options":_vm.agencias,"disabled":_vm.disabled,"required":_vm.required,"single":_vm.single},model:{value:(_vm.agencia),callback:function ($$v) {_vm.agencia=$$v},expression:"agencia"}})}
var staticRenderFns = []

export { render, staticRenderFns }